import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPhotoUploaderComponent } from './user-photo-uploader.component';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../header/header.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SecureImageModule } from '../secure-image/secure-image.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { KioskCameraModule } from '../kiosk-camera/kiosk-camera.module';



@NgModule({
  declarations: [
    UserPhotoUploaderComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    HeaderModule,
    SidebarModule,
    FormsModule,
    ReactiveFormsModule,
    SecureImageModule,
    DirectivesModule,
    NgxUiLoaderModule,
    KioskCameraModule
  ],
  exports: [
    UserPhotoUploaderComponent
  ]
})
export class UserPhotoUploaderModule { }
